import { AppRegistration } from '../model/AppRegistration';
import { UserType } from '../store/session/SessionState';
import { ApiResponse, customFetch } from './CustomFetch';

export const fetchUiAppRegistration = (typeOfUser: UserType) => {
  return customFetch(`settings/ui-app-registration/${typeOfUser}`, undefined, false)
    .then((response) => response?.json() as Promise<ApiResponse<AppRegistration>>)
    .then((jsonResponse) => jsonResponse?.data);
};
